import { createSlice } from "@reduxjs/toolkit";
import Knowledge from "../../pages/BotSetting/Knowledge";

export const initialState = {
  Favourite_Prompt_List: [],
  loading: false,
  error_message: "",
  error: false,
  Favorite_Prompt_Category: [],
  Prompt_Question: null,
  Prompt_Description: "",
  open_favourite_modal: false,
  edit_mode: false,
  

  Fav_Prompt_SQL_Result:[],
  Fav_Prompt_SQL_Result_Loader:false,

  // Fav Prompt Creation Values .
  fullresponse: null,
  query: null,
  question: null,                  

  // edit values .
  Allow_User_Run_Prompt: null,
  Allow_User_Run_SQL: null,
  Allow_User_See_Prompt_SQL: null,
  Bot_FavoutBot_Favorite_Prompt_ID: null,
  Bot_ID: null,
  Description: null,
  Email: null,
  Mobile_Number: null,
  Notification_Type: null,
  PromptFrequencyType: null,
  Prompt_Category: null,
  Prompt_Question: null,
  Prompt_Refresh_Frequency: null,
  Prompt_Result: null,
  Prompt_Result_History: null,
  Prompt_Result_Time: null,
  Prompt_SQL: null,
  RunTime: null,
  Updated_at: null,
  Updated_by: null,
  User_ID: null,
  WeeklyDays: null,
  assistant_id: null,
  only_download: null,
  thread_id: null,
  Notification_Email:null,
  Notification_Mobile:null,
  Allow_Only_Download:null,
  description:null,
  Mongo_Query:null,
  Prompt_Result:null,
  LastPromptCategory:null,
  PromptDescription:null
  
};

const Favorite_Prompt_Slice = createSlice({
  name: "Create_New_Bot",
  initialState,
  reducers: {
    start_Fav_Prompt_Loading(state, payload) {
      state.loading = true;
    },
    start_Fav_Prompt_SQL_Loading(state, payload) {
      state.Fav_Prompt_SQL_Result_Loader = true;
    },

    set_Fav_Prompt_List_Success(state, action) {
      state.loading = false;
      state.Favourite_Prompt_List = action.payload;
      state.error = false;
    },

    set_Favorite_Prompt_reset(state, action) {
      state.Favourite_Prompt_List = [];
      state.error = false;
    },

    set_Fav_Prompt_List_Fail(state, action) {
      state.loading = false;
      state.error = true;
      state.error_message = action.payload;
    },
    set_Fav_Prompt_Category_Success(state, action) {
      state.loading = false;
      state.error = false;
      state.Favorite_Prompt_Category = action.payload.map(
        (category) => category.Prompt_Category
      );
    },
    set_Fav_Prompt_Category_Fail(state, action) {
      state.loading = false;
      state.error = true;
      state.error_message = action.payload;
    },

    set_Fav_Prompt_Question(state, action) {
      state.Prompt_Question = action.payload;
    },
    set_Fav_Prompt_Question_reset(state, action) {
      state.Prompt_Question = null;
    },

    set_Fav_Prompt_Question_SQL_success(state, action) {
      const { fullresponse, query, question , mongo_query , LastPromptCategory  , PromptDescription} = action.payload;
      state.fullresponse = fullresponse;
      state.query = query;
      state.Mongo_Query = mongo_query;
      state.question = question;
      state.loading = false;
      state.Prompt_Description = PromptDescription
      state.LastPromptCategory = LastPromptCategory
    },
    set_Fav_Prompt_Question_SQL_fail(state, action) {
      state.error = action.payload;
      state.loading = false;
    },
    set_fav_prompt_Description(state, action) {
      state.Prompt_Description = action.payload;
    },
    save_fav_prompt_success(state, action) {
      state.loading = false;
    },
    save_fav_prompt_fail(state, action) {
      state.loading = false;
      state.error = true;
      state.error_message = action.payload;
    },
    delete_fav_prompt_success(state, action) {
      state.loading = false;
    },
    delete_fav_prompt_fail(state, action) {
      state.loading = false;
      state.error = true;
      state.error_message = action.payload;
    },
    open_favourite_modal(state, action) {
      state.edit_mode = true;
      state.open_favourite_modal = true;
    
    },
    close_favourite_modal(state, action) {
      state.open_favourite_modal = false;
      state.edit_mode = false;
      state.Prompt_Description = null
    },
    set_fav_prompt_modal_edit_mode_values(state, action) {
      const {
        Bot_ID,
        assistant_id,
        thread_id,
        Prompt_Category,
        Prompt_Question,
        Prompt_Refresh_Frequency,
        Notification_Email,
        Notification_Mobile,
        Prompt_Result_Time,
        Prompt_Result,
        Allow_User_Run_Prompt,
        Allow_User_Run_SQL,
        Allow_User_See_Prompt_SQL,
        Allow_Only_Download,
        query,
        question,
        Description,
        PromptFrequencyType,
        WeeklyDays,
        Bot_Favorite_Prompt_ID,
        Prompt_SQL,
        Mongo_Query
      } = action.payload;
      state.edit_mode = true;
      state.Bot_ID = Bot_ID;
      state.assistant_id = assistant_id;
      state.thread_id = thread_id;
      state.Prompt_Category = Prompt_Category;
      state.Prompt_Question = Prompt_Question;
      state.Prompt_Refresh_Frequency = Prompt_Refresh_Frequency;
      state.Notification_Email = Notification_Email;
      state.Notification_Mobile = Notification_Mobile;
      state.Prompt_Result_Time = Prompt_Result_Time;
      state.Allow_User_Run_Prompt = Allow_User_Run_Prompt;
      state.Allow_User_Run_SQL = Allow_User_Run_SQL;
      state.Allow_User_See_Prompt_SQL = Allow_User_See_Prompt_SQL;
      state.Allow_Only_Download = Allow_Only_Download;
      state.query = query;
      state.question = Prompt_Question;
      state.Prompt_Result = Prompt_Result;
      // state.description = description;
      state.PromptFrequencyType = PromptFrequencyType;
      state.WeeklyDays = WeeklyDays;
      state.Bot_Favorite_Prompt_ID = Bot_Favorite_Prompt_ID;
      // state.question = Prompt_Question
      state.Prompt_Description=Description
      state.Prompt_SQL = Prompt_SQL
      state.Mongo_Query = Mongo_Query
    },

    update_favorite_prompt_success(state,action){
         state.loading = false;
         state.edit_mode = false;
         state.open_favourite_modal =false
         state.Prompt_Category =null
    },
    update_favorite_prompt_fail(state,action){
      state.Fav_Prompt_SQL_Result_Loader = false;
      state.loading = false;
      state.error = true;
      state.error_message =action.payload;
 },
 set_fav_prompt_sql_result(state,action){
    state.Fav_Prompt_SQL_Result_Loader = false;
    state.Fav_Prompt_SQL_Result=action.payload.result
 }
  },
});

export const {
  set_Fav_Prompt_List_Success,
  set_Favorite_Prompt_reset,
  set_Fav_Prompt_List_Fail,
  start_Fav_Prompt_Loading,
  set_Fav_Prompt_Category_Success,
  set_Fav_Prompt_Category_Fail,
  set_Fav_Prompt_Question,
  set_Fav_Prompt_Question_reset,
  set_Fav_Prompt_Question_SQL_success,
  set_Fav_Prompt_Question_SQL_fail,
  set_fav_prompt_Description,
  save_fav_prompt_success,
  save_fav_prompt_fail,
  delete_fav_prompt_success,
  delete_fav_prompt_fail,
  set_fav_prompt_modal_edit_mode,
  close_favourite_modal,
  open_favourite_modal,
  set_fav_prompt_modal_edit_mode_values,
  update_favorite_prompt_success,
  update_favorite_prompt_fail,
  set_fav_prompt_sql_result,
  start_Fav_Prompt_SQL_Loading

} = Favorite_Prompt_Slice.actions;

export default Favorite_Prompt_Slice.reducer;
